module.exports = __webpack_public_path__ + "static/media/4.eaa1804a.jpg";